// Video demo configuration
// Only includes exercises with real, working video URLs
// Exercises without videos will show diagrams and written instructions instead

export const videoDemos = {
  // Add real video demos here when available
  // Example format:
  // "exercise-id": {
  //   "title": "Exercise Name Demo",
  //   "description": "Description of the demo",
  //   "duration": "2:30",
  //   "instructor": "Instructor Name",
  //   "videoUrl": "https://real-video-url.com/video",
  //   "thumbnailUrl": "/images/exercises/thumbnail.jpg",
  //   "difficulty": "Beginner",
  //   "equipment": "None",
  //   "safetyNotes": ["Safety note 1", "Safety note 2"],
  //   "isDemo": true
  // }
};

export const videoMetadata = {
  "generatedAt": "2025-10-09T00:00:00.000Z",
  "totalDemos": 0,
  "note": "Video demos will be added as they become available. Exercises without videos show diagrams and written instructions."
};

// Helper function to get video demo by exercise ID
export function getVideoDemo(exerciseId) {
  return videoDemos[exerciseId] || null;
}

// Helper function to check if video demo exists
export function hasVideoDemo(exerciseId) {
  return !!videoDemos[exerciseId];
}

// Helper function to get all available video demos
export function getAllVideoDemos() {
  return Object.keys(videoDemos).map(id => ({
    exerciseId: id,
    ...videoDemos[id]
  }));
}
